import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { CmsPostFilterPublic, CmsPostPublicSortByEnum } from 'graphql/generated';
import { Post } from '@app/core/interfaces/post.interface';
import { formatPostData } from '@app/core/utils/post-mapper.util';
import { PostService } from '@app/core/services/post.service';
import { ContentCardComponent } from '../cards/content/content-card.component';

@Component({
  standalone: true,
  selector: 'ups-content-section',
  host: { class: 'd-block w-100' },
  templateUrl: './content-section.component.html',
  styleUrls: ['./content-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule,
    RouterModule,
    TranslocoModule,
    ContentCardComponent
  ],
})
export class ContentSectionComponent implements OnChanges, OnDestroy {
  
  @Input({ required: true }) public mode!: string;
  @Input() public moreUrl: string = '';
  @Input() public hideAble: boolean = false;
  public isShowing: boolean = true;
  public data: (Post | undefined)[] = [ undefined, undefined, undefined ];
  protected sub?: Subscription;
  
  constructor(
    protected readonly ch: ChangeDetectorRef,
    protected readonly postService: PostService,
  ) { }

  public ngOnChanges(changes: SimpleChanges): void{
    if (!changes['mode']) return;
    if (this.hideAble && /Mobi/i.test(window.navigator.userAgent)) return;

    this.sub?.unsubscribe();
    this.data = [ undefined, undefined, undefined ];

    const filter: CmsPostFilterPublic = { pageSize: 3, sortBy: CmsPostPublicSortByEnum.PublishedAt, sortDirection: 'DESC', isPinned: false };
    if (this.mode !== 'Latest') filter.termName = this.mode;

    this.sub = this.postService.query(filter, '', this.mode === 'Latest').subscribe({
      error: () => this.setIsShowing(false),
      next: ({ data: { cmsMsPostsPublic: { edges }}}) => {
        if (!edges || edges.length === 0) {
          this.setIsShowing(false);
          return;
        }

        edges?.forEach((d: any, i) => this.data[i] = formatPostData(d.node));

        this.data.length = edges?.length!;
        this.setIsShowing(true);
      }
    });
  }

  public ngOnDestroy(): void{ this.sub?.unsubscribe(); }

  protected setIsShowing(b: boolean): void{
    this.isShowing = b;
    this.ch.markForCheck();
  }
}
